<template>
  <div
    class="absolute inset-0 flex items-center justify-center z-10 cursor-pointer overflow-hidden"
    @click="handleAdultConfirmation"
  >
    <div
      class="absolute inset-0 bg-gray-500 bg-white/30 rounded-xl"
      :style="{ backdropFilter: 'blur(20px)' }"
    />
    <IconAdult class="z-10" />
  </div>
</template>

<script>
import IconAdult from '~/assets/svg/lot-page/adult.svg?component'
export default {
  components: {
    IconAdult,
  },
  setup () {
    const { setIsAdultConfirmed } = useGlobal()
    return { setIsAdultConfirmed }
  },
  methods: {
    handleAdultConfirmation () {
      this.$tracking.logEventAmplitude('show confirmation', {
        'confirmation type': 'AGE',
      })
      this.$modal.show('shared/modal/adult_confirmation', {
        minWidthClass: 'sm:min-w-[328px]',
        centered: true,
        confirmationMethod: () => {
          const rmAdultConfirmedCookie = useAppCookie('rm_adult_confirmed')
          rmAdultConfirmedCookie.value = true
          this.setIsAdultConfirmed(true)
        },
      })
    },
  },
}
</script>
